


import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ClatHardcopyRoutingModule } from './clat-hardcopy-routing.module';
import { ClatHardcopyComponent, FormDialog, thankyoudialog } from './clat-hardcopy.component';
import { ComponentsModule } from '../components/components.module';
import { ChildComponentsModule } from '../components/child-components.module';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatDialogModule } from '@angular/material/dialog';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { ReactiveFormsModule } from '@angular/forms';
import { MAT_AUTOCOMPLETE_SCROLL_STRATEGY, MatAutocompleteModule } from '@angular/material/autocomplete';
import { BlockScrollStrategy, Overlay } from '@angular/cdk/overlay';
import { CommonChildComponentsModule} from '../components/common-components.module'

export function scrollFactory(overlay: Overlay): () => BlockScrollStrategy {
  return () => overlay.scrollStrategies.block();
}

@NgModule({
  declarations: [
    ClatHardcopyComponent,
    FormDialog,
    thankyoudialog
  ],
  imports: [
    CommonModule,
    ClatHardcopyRoutingModule,
    ChildComponentsModule,
    CommonChildComponentsModule,
ComponentsModule,
    MatInputModule,
    MatFormFieldModule,
    MatDialogModule,
    MatSnackBarModule,
    ReactiveFormsModule,
    MatAutocompleteModule
  ],
  providers:[
    {
      provide: MAT_AUTOCOMPLETE_SCROLL_STRATEGY,
      useFactory: scrollFactory,
      deps: [Overlay],
    },
  ]
})
export class ClatHardcopyModule { }
